import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import mapValues from "lodash/mapValues";
import omit from "lodash/omit";
import { warning } from "@jutro/logger";
var SAFE_PREFIXES = ["/", "http", "https", "mailto:", "tel:"],
  DANGEROUS_PROPS = ["href", "to", "action"];
export function isSafeUrl(url) {
  return !url || SAFE_PREFIXES.some(function (prefix) {
    return _startsWithInstanceProperty(url).call(url, prefix);
  });
}
export function sanitizeUrl(url) {
  var _context,
    allowNoLeadingSlash = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  return url && "string" != typeof url || !isSafeUrl(url) && !allowNoLeadingSlash ? (warning(_concatInstanceProperty(_context = "'".concat(url, "' is not a safe url value. The only allowed urls are the ones starting with: ")).call(_context, SAFE_PREFIXES.join(", "))), "") : url;
}
export function sanitizeRouterTo(to) {
  return "string" == typeof to ? sanitizeUrl(to) : to ? _objectSpread(_objectSpread({}, to), {}, {
    pathname: to.pathname && sanitizeUrl(to.pathname)
  }) : to;
}
export function sanitizeProps(props) {
  return mapValues(props, sanitizeProp);
}
function sanitizeProp(value, key) {
  return _includesInstanceProperty(DANGEROUS_PROPS).call(DANGEROUS_PROPS, key) && "string" == typeof value ? sanitizeUrl(value) : value;
}
export function removeDangerousProps(props) {
  return omit(props, "dangerouslySetInnerHTML");
}